import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const groupConfidentialityDeedApi = {
    getGroupConfidentialityDeedByGroupId: (groupId: number): Observable<Dtos.GetGroupConfidentialityDeedByGroupIdResponse> => {
        //Create the request.
        let request: Dtos.GetGroupConfidentialityDeedByGroupId = new Dtos.GetGroupConfidentialityDeedByGroupId();
        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.GetGroupConfidentialityDeedByGroupIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getGroupConfidentialityDeedById: (id: number): Observable<Dtos.GetGroupConfidentialityDeedByIdResponse> => {
        //Create the request.
        let request: Dtos.GetGroupConfidentialityDeedById = new Dtos.GetGroupConfidentialityDeedById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetGroupConfidentialityDeedByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setGroupConfidentialityDeed: (groupConfidentialityDeed: Dtos.GroupConfidentialityDeed): Observable<Dtos.SetGroupConfidentialityDeedResponse> => {

        let request: Dtos.SetGroupConfidentialityDeed = new Dtos.SetGroupConfidentialityDeed();

        request.groupConfidentialityDeed = groupConfidentialityDeed;

        // send request
        const response: Promise<Dtos.SetGroupConfidentialityDeedResponse> = client.post(request);

        return Observable.from(response);
    },
    createGroupConfidentialityDeed: (groupId: number): Observable<Dtos.CreateGroupConfidentialityDeedResponse> => {
        //Create the request.
        let request: Dtos.CreateGroupConfidentialityDeed = new Dtos.CreateGroupConfidentialityDeed();

        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.CreateGroupConfidentialityDeedResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    deleteGroupConfidentialityDeed: (id: number): Observable<Dtos.DeleteGroupConfidentialityDeedResponse> => {
        //Create the request.
        let request: Dtos.DeleteGroupConfidentialityDeed = new Dtos.DeleteGroupConfidentialityDeed();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.DeleteGroupConfidentialityDeedResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateGroupConfidentialityDeed: (groupConfidentialityDeed: Dtos.GroupConfidentialityDeed): Observable<Dtos.ValidateGroupConfidentialityDeedResponse> => {

        let request: Dtos.ValidateGroupConfidentialityDeed = new Dtos.ValidateGroupConfidentialityDeed();

        request.groupConfidentialityDeed = groupConfidentialityDeed;

        // send request
        const response: Promise<Dtos.ValidateGroupConfidentialityDeedResponse> = client.post(request);

        return Observable.from(response);
    },
}